import React from 'react';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';

const messages = defineMessages({
  'prospectus.course.snapshot.price.only-free': {
    id: 'prospectus.course.snapshot.price.only-free',
    defaultMessage: 'Free',
    description: 'Heading indicating that the course is free',
  },
  'prospectus.course.snapshot.price.no-cost-access': {
    id: 'prospectus.course.snapshot.price.no-cost-access',
    defaultMessage: 'Access to course at no cost',
    description: 'This describes that the course is always free',
  },
});

function FreeLanguage({ intl }) {
  return (
    <>
      <div className="h4 mb-0">
        {intl.formatMessage(messages['prospectus.course.snapshot.price.only-free'])}
      </div>
      <div className="small">
        {intl.formatMessage(messages['prospectus.course.snapshot.price.no-cost-access'])}
      </div>
    </>
  );
}

FreeLanguage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(FreeLanguage);
